import React from "react";
import {createRoot} from "react-dom/client";
import {HashRouter as Router, Routes, Route} from 'react-router-dom';
import "./components/Site.css";
import App from "./components/App";
import Chat from "./components/Chat";
import News from "./components/News";
import Airline from "./components/Airline";

const root = createRoot(document.getElementById("root"));
root.render(
    <Router>
        <Routes>
            <Route exact path="/" element={<App/>}/>
            <Route path="/news" element={<News/>}/>
            <Route path="/chat" element={<Chat/>}/>
            <Route path="/airline" element={<Airline/>}/>
        </Routes>
    </Router>
);

// textbox filter

/*
<input onChange={(event) => {
    const searchString = event.target.value.toLocaleLowerCase();
    const filteredMonsters = this.state.monsters.filter((monster) => {
        return monster.name.toLocaleLowerCase().includes(searchString);
    });

    // set the state to only filtered monsters. From there, you can render them
    this.setState(() => {
        return {monsters: filteredMonsters};
    });
}}
*/